import React from 'react';
import { RentalItem } from './RentalItem';
import { InfoIcon, AlertCircle } from 'lucide-react';
export function RentalForm({
  selections,
  onSelectionChange,
  onTechToggle,
  prices
}) {
  return <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-483">
      <h2 className="text-xl font-semibold mb-6 text-blue-800" data-id="element-484">
        Select Your Equipment
      </h2>
      {/* Tournament Equipment Group */}
      <div className="mb-8" data-id="element-485">
        <h3 className="text-lg font-medium text-blue-800 mb-4 pb-2 border-b border-slate-200" data-id="element-486">
          Tournament Equipment
        </h3>
        <div className="space-y-4" data-id="element-487">
          <RentalItem title="Full Gen 3 Ring" description="Includes two judges and size 0-4 hogus (Head not included - Most common starting point)" price={prices.fullGen3Ring} value={selections.fullGen3Ring} onChange={value => onSelectionChange('fullGen3Ring', value)} highlight={true} data-id="element-488" />
          <RentalItem title="Gen 3 Head" description="Includes sizes S-L (Requires at least one Gen 3 Body)" price={prices.gen3Head} value={selections.gen3Head} onChange={value => onSelectionChange('gen3Head', value)} disabled={selections.gen3Body + selections.fullGen3Ring === 0} maxValue={selections.gen3Body + selections.fullGen3Ring} validationMessage={selections.gen3Body + selections.fullGen3Ring === 0 ? 'At least one Gen 3 Body or Full Gen 3 Ring is required' : `Maximum ${selections.gen3Body + selections.fullGen3Ring} allowed`} data-id="element-489" />
        </div>
      </div>
      {/* Training Equipment Group */}
      <div className="mb-8" data-id="element-490">
        <h3 className="text-lg font-medium text-blue-800 mb-4 pb-2 border-b border-slate-200" data-id="element-491">
          Training Equipment
        </h3>
        <div className="space-y-4" data-id="element-492">
          <RentalItem title="Gen 3 Body" description="Includes sizes 0-4 without judges" price={prices.gen3Body} value={selections.gen3Body} onChange={value => onSelectionChange('gen3Body', value)} data-id="element-493" />
          <RentalItem title="Gen 3 Judges Only" description="Includes 2 judge boxes per ring" price={prices.gen3JudgesOnly} value={selections.gen3JudgesOnly} onChange={value => onSelectionChange('gen3JudgesOnly', value)} priceDisplay={`$${prices.gen3JudgesOnly.toFixed(2)} per set`} data-id="element-494" />
        </div>
      </div>
      {/* Technician Option - Now Required */}
      <div className="border-t border-slate-200 pt-6" data-id="element-495">
        <div className="bg-red-50 border-2 border-red-200 rounded-lg p-4 mb-4" data-id="element-496">
          <div className="flex items-start" data-id="element-497">
            <AlertCircle className="h-5 w-5 text-red-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-498" />
            <div data-id="element-499">
              <h4 className="font-semibold text-red-800 mb-1" data-id="element-500">
                On-site Technician Required
              </h4>
              <p className="text-sm text-red-700" data-id="element-501">
                An on-site technician is mandatory for all equipment rentals to
                ensure proper setup and operation.
              </p>
            </div>
          </div>
        </div>
        <div className="flex items-start" data-id="element-502">
          <div className="flex items-center h-5" data-id="element-503">
            <input id="requireTech" type="checkbox" checked={selections.requireTech} onChange={onTechToggle} className="h-5 w-5 rounded border-slate-300 text-red-600 focus:ring-red-500" data-id="element-504" />
          </div>
          <div className="ml-3 text-sm" data-id="element-505">
            <label htmlFor="requireTech" className="font-medium text-slate-700" data-id="element-506">
              Require On-site Technician <span className="text-red-600" data-id="element-507">*</span>
            </label>
            <div className="flex items-center text-slate-500 mt-1" data-id="element-508">
              <InfoIcon size={16} className="mr-1" data-id="element-509" />
              <p data-id="element-510">
                ${prices.technician.toFixed(2)} per day - Required for all
                rentals
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}